<template>
    <v-sheet ref="layoutBlock">
        <div class="d-flex flex-column">
            <v-icon v-if="!reduced" class="d-flex justify-end pa-2" @click="tutorial_dialog.dialog = true">help_outline</v-icon>         
        <slot></slot>
        <TutorialDialog
            :data="tutorial_dialog"
            @close_dialog="handleCloseDialog"/>
        </div>
        <weightSelectionDialog
            ref="weightSelectionDialog"
            @weightsConfirmed="handleWeightsConfirmed"
        />
        <weights-view-dialog
            ref="weightViewDialog">

        </weights-view-dialog>
        <ConfirmDialog
            :data="confirmData"
            v-on:close_dialog="handleCloseDialog"
            v-on:confirm_result="handleConfirm"
        />
        
    </v-sheet>
</template>

<script>
import weightSelectionDialog from "./WeightSelectionDialog"
import TutorialDialog from "../dialogs/TutorialDialog"
import ConfirmDialog from "../dialogs/ConfirmDialog"
import WeightsViewDialog from './WeightsViewDialog.vue'
export default {
    components: {TutorialDialog, weightSelectionDialog, ConfirmDialog, WeightsViewDialog },
    props: {
        tutorial_dialog: {
            type: Object,
            required: true
        },
        reduced : {
            type: Boolean,
            required: false,
            default: false
        }
    },
    data() {
        return {
            weights_dialog: {text: "ciao ciao", dialog: false},
            confirmData: {
                dialog: false,
                title: 'Valore nominale',
                message: "Vuoi aggiornare il valore nominale?",
                choices: [
                    {key: "cancel", val: "annulla", mod: "success"},
                    {key: "confirm", val: "conferma"}
                    ]
                },
        }
    },
    methods: {
        handleCloseDialog(){
            this.$emit('closeDialog');
        },
        openDialog(nom, weights, instrument_uom, precision, selected = []){
            // console.log("weights", weights)
            this.$refs.weightSelectionDialog.openDialog(nom, weights, instrument_uom, precision, selected)
        },
        openViewDialog(items, primaries, uom){
            this.$refs.weightViewDialog.openDialog(items, primaries, uom)
        },
        handleWeightsConfirmed(weights){
            // console.log("confirmed weights ==> ", weights)
            this.$emit('weightsConfirmed', weights)
        },
        openConfirm(nom){
            // console.log("opening confirm dialog")
            this.confirmData.customData = nom
            this.confirmData.dialog = true
        },
        handleConfirm(key){
            // console.log("confirmed option", key)
            this.confirmData.dialog = false
            this.$emit("handleConfirm", key)
        }
    }
}
</script>

<style>
.no_space {
    padding: 0px;
    margin: 0px;
}

.no_space_vertical {
    padding-top: 0px;
    padding-bottom: 0px;
    margin-top: 0px;
    margin-bottom: 0px;
}
.relative {
    position: relative;
}
</style>
